import { AxiosInstance } from 'axios';
import { ArgumentValidator } from '../../helpers';
import { QueryStringBuilder } from '../helpers/query-string-builder';
import { IPagedList } from '../models';
import { IAgendaImportStatusResponse, IAgendaTemplate, IListAgendaTemplateRequest, INewAgendaTemplate } from '../models/agenda';

export class AgendaTemplateClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/agendaTemplate`;
    }

    public async create(activityId: string, template: INewAgendaTemplate): Promise<IAgendaTemplate> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        try {
            const response = await this.axiosClient.post(
                `${this.apiUrl}/${activityId}`,
                template,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async list(request: IListAgendaTemplateRequest, organizationalUnitPath: string, staleId?: string): Promise<IPagedList<IAgendaTemplate>> {

        const url = new QueryStringBuilder()
                .withPaginationIfNotEmpty(request.pagination)
                .withQueryIfNotEmpty('staleId', staleId)
                .withQueryIfNotEmpty('organizationalUnitPath', organizationalUnitPath)
                .build(`${this.apiUrl}`);

        try {
            const response = await this.axiosClient.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async import(activityId: string, templateId: string): Promise<void> {

        try {

            const response = await this.axiosClient.post(
                `${this.apiUrl}/${activityId}/import/${templateId}`,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async getImportStatus(activityId: string, templateId: string): Promise<IAgendaImportStatusResponse> {

        try {

            const response = await this.axiosClient.get(
                `${this.apiUrl}/${activityId}/import/${templateId}/status`,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async delete(id: string): Promise<void> {

        try {

            const response = await this.axiosClient.delete(
                `${this.apiUrl}/${id}`,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
